import React, { Component } from 'react';
import { Route } from 'react-router';
import { DongFangXiWang } from './components/dongfangxiwang_components/DongFangXiWang';
import { DrientalYuhong } from './components/drientalyuhong_components/DrientalYuhong';
import { HeSi } from './components/hesi_components/HeSi';
import { HeSiShowTag } from './components/hesi_components/HeSiShowTag';
import { ErrorMessage } from './components/ErrorMessage';
import { HisenseComponent } from './components/hisence_components/HisenseComponent';
import { HisenseInvalidEvaluation } from './components/hisence_components/HisenseInvalidEvaluation';
import { HisenseInvalidSuccess } from './components/hisence_components/HisenseInvalidSuccess';
import { HisenseSuccess } from './components/hisence_components/HisenseSuccess';
import { Home } from './components/Home';
import { Layout } from './components/Layout';
import { MingYangTaleBaseProduct } from './components/mingyang_components/MingYangTaleBaseProduct';
import { NewHopeWorkPlace } from './components/newhope_components/NewHopeWorkPlace';
import { NewHopeWorkProvince } from './components/newhope_components/NewHopeWorkProvince';
import { Test } from './components/Test';

import { HisenseUpdateResumeTrigger } from './components/hisence_components/HisenseUpdateResumeTrigger';

import { CansinoComponent } from './components/cansino_components/Cansino';
import { ChangJiangCunChuEvaluationReport } from './components/changjiangcunchu_components/ChangJiangCunChuEvaluationReport';
import { ChangJiangCunChuInitiateEvaluation } from './components/changjiangcunchu_components/ChangJiangCunChuInitiateEvaluation';
import { SFCheck } from './components/changxincunchu_components/SFCheck';
import { CxmtConfirmToSend } from './components/cxmt_components/CxmtConfirmToSend';
import { CxmtEvaluationSend } from './components/cxmt_components/CxmtEvaluationSend';
import { ElectSignConfirm } from './components/drientalyuhong_components/ElectSignConfirm';
import { EnnSendSuccess } from './components/enn_components/EnnSendSuccess';
import { JobPortrait } from './components/fangtai_components/JobPortrait';
import { JiangNanNongShang } from './components/jiangnanmnongshang_components/JiangNanNongShang';
import { MaiRui } from './components/mairui_components/MaiRui';
import { MaiRuiBeiDiao } from './components/mairui_components/MaiRuiBeiDiao';
import { BaseSalaryComponent } from './components/mindray_components/BaseSalary';
import { OfferBatchComponent } from './components/mindray_components/OfferBatch';
import { OperationSuccess } from './components/mindray_components/OperationSuccess';
import { SPSalaryComponent } from './components/mindray_components/SpSalary';
import { NovaEHRPush } from './components/novastar_components/NovaEHRPush';
import { SanQiHuYuInviteReject } from './components/sanqihuyu_components/SanQiHuYuInviteReject';
import { SanQiHuYuInviteRejectSuccess } from './components/sanqihuyu_components/SanQiHuYuInviteRejectSuccess';
import { SanQiHuYuInviteSuccess } from './components/sanqihuyu_components/SanQiHuYuInviteSuccess';
import { SanQiHuYuInviteToExam } from './components/sanqihuyu_components/SanQiHuYuInviteToExam';
import { SanQiHuYuInviteUpdateTime } from './components/sanqihuyu_components/SanQiHuYuInviteUpdateTime';
import { SanQiHuYuSendSuccess } from './components/sanqihuyu_components/SanQiHuYuSendSuccess';
import { SanQiHuYuSendWrittenExam } from './components/sanqihuyu_components/SanQiHuYuSendWrittenExam';
import { SanQiHuYuWrittenResult } from './components/sanqihuyu_components/SanQiHuYuWrittenResult';
import { SfcExam } from './components/sfcexamination_components/SfcExam';
import { Starbucks_BPMHiringApply } from './components/starbucks_components/Starbucks_BPMHiringApply';
import { Starbucks_BPMSendHiring } from './components/starbucks_components/Starbucks_BPMSendHiring';
import { Starbucks_TransferToCancel } from './components/starbucks_components/Starbucks_TransferToCancel';
import { xinding } from './components/xinding_components/xinding';
import { XinWangDaBackground } from './components/xinwangda_components/XinWangDaBackground';
import { YangguangRedirect } from './components/yangguang_components/YangguangRedirect';
import { ZhuoYue } from './components/zhuoyue_components/ZhuoYue';
import { ZjwjPush } from './components/zjwj_components/ZjwjPush';
import { SunshineReferView } from './components/sunshine_components/getreferrerinformation';
import { NeusoftReferView } from './components/Neusoft_components/getDimissionInfo';
import { XdfEditApplicant } from './components/xdf_components/xdf_edit_applicant';
import { XdfOffer } from './components/xdf_components/xdfoffer';
import { SAPushinfos } from './components/sawt_components/SAPushinfos';
import { Sinosig_QuestionBank } from './components/sinosig_components/Sinosig_QuestionBank';
import { Cqtj_OfferApply } from './components/cqtj_components/Cqtj_OfferApply';
import { AssessmentInterviewer } from './components/zhongjin_components/AssessmentInterviewer';
import { AssessmentHR } from './components/zhongjin_components/AssessmentHR';
import { employeapply } from './components/haoweilai_components/employeapply';
import { ZhongJiaoReferView } from './components/zhongjiao_components/ZhongJiaoEvaRefer';
import { LingShuBackGroundRecord } from './components/lingshu_components/BackGroundRecord';
import SHL_Evaluation from './components/lehe_components/SHL_Evaluation';
import { HeShine } from './components/heshine_components/HeShine';
import { MaiRuiPhysicalExamination } from './components/mairui_components/MaiRuiPhysicalExamination';
import { MaiRuiSubmitPhysicalExamination } from './components/mairui_components/MaiRuiSubmitPhysicalExamination';

import { CCCCLTDPersonWish } from './components/ccccltd_components/ccccltd_wish_components/CCCCLTDPersonWish';
import { CCCCLTDPersonStoreDB } from './components/ccccltd_components/ccccltd_storedb_components/CCCCLTDPersonStoreDB';
import { CCCCLTDJumpInfo } from './components/ccccltd_components/ccccltd_jumpinfo_components/CCCCLTDJumpInfo'
import { CCCCLTDOrgDecide } from './components/ccccltd_components/ccccltd_oldorg_components/CCCCLTDOrgDecide'
import { CCCCLTDOrgResult } from './components/ccccltd_components/ccccltd_oldorg_components/CCCCLTDOrgResult'
import { CCCCLTDOrgTwiceResult } from './components/ccccltd_components/ccccltd_oldorg_components/CCCCLTDOrgTwiceResult'
import { CCCCLTDApplicantApply } from './components/ccccltd_components/ccccltd_oldorg_components/CCCCLTDApplicantApply'

import { CSPCFamilyApply } from './components/cspc_components/cspc_family_apply_components/CSPCFamilyApply'

import { ZhongKeJin } from './components/zkj_components/zjkJs'; import './custom.css'
import Invitation from './components/internship-invitation/invitation'
import Accept from './components/internship-invitation/accept'
import Refuse from './components/internship-invitation/refuse'
import CommitmentLetter from './components/pengxinwei_components/commitment-letter'

export default class App extends Component {
    static displayName = App.name;
    render() {
        return (
            <Layout>
                <Route exact path='/' component={Home} />
                <Route path='/test' component={Test} />
                <Route path='/ErrorMessage' component={ErrorMessage} />
                <Route path='/hesi_pi/index' component={HeSi} />
                <Route path='/hesi_pi/showTagPage' component={HeSiShowTag} />
                <Route exact path='/mingyang_talebaseproduct/index' component={MingYangTaleBaseProduct} />
                <Route exact path='/newhope_work_province/index' component={NewHopeWorkProvince} />
                <Route exact path='/newhope_work_place/index' component={NewHopeWorkPlace} />
                <Route exact path='/driental_yuhong/index' component={DrientalYuhong} />
                <Route exact path="/hisense_evacuation" component={HisenseComponent} />
                <Route exact path="/hisense_success" component={HisenseSuccess} />
                <Route exact path='/zhuoyue_jump/index' component={ZhuoYue} />
                <Route exact path="/hisense_invalid_success" component={HisenseInvalidSuccess} />
                <Route exact path="/invalid_evaluation" component={HisenseInvalidEvaluation} />
                <Route exact path="/select_paper" component={SfcExam} />
                <Route exact path="/jiangnannongshang" component={JiangNanNongShang} />
                <Route exact path="/mairuiplandate" component={MaiRui} />
                <Route exact path="/mairuibeidiao" component={MaiRuiBeiDiao} />
                <Route exact path="/mairuiphysicalexamination" component={MaiRuiPhysicalExamination} />
                <Route exact path="/mairuisubmitphysicalexamination" component={MaiRuiSubmitPhysicalExamination} />
                <Route exact path="/cf_check/index" component={SFCheck} />
                <Route exact path="/changjiangcunchuevaluationreport" component={ChangJiangCunChuEvaluationReport} />
                <Route exact path="/changjiangcunchuinitiateevaluation" component={ChangJiangCunChuInitiateEvaluation} />
                <Route exact path="/sanqihuyu_send_written_exam" component={SanQiHuYuSendWrittenExam} />
                <Route exact path="/sanqihuyu_send_success" component={SanQiHuYuSendSuccess} />
                <Route exact path="/stb/applicant/TransferToCancel" component={Starbucks_TransferToCancel} />
                <Route exact path="/sanqihuyu_invite_success" component={SanQiHuYuInviteSuccess} />
                <Route exact path="/sanqihuyu_invite_to_exam" component={SanQiHuYuInviteToExam} />
                <Route exact path="/sanqihuyu_invite_reject" component={SanQiHuYuInviteReject} />
                <Route exact path="/sanqihuyu_invite_updatetime" component={SanQiHuYuInviteUpdateTime} />
                <Route exact path="/sanqihuyu_invite_reject_success" component={SanQiHuYuInviteRejectSuccess} />
                <Route exact path="/sanqihuyu_written_result" component={SanQiHuYuWrittenResult} />
                <Route exact path="/cansino" component={CansinoComponent} />
                <Route exact path="/cxmtConfirmToSend" component={CxmtConfirmToSend} />
                <Route exact path="/CxmtEvaluationSend" component={CxmtEvaluationSend} />
                <Route exact path="/hisense_updateresumetrigger" component={HisenseUpdateResumeTrigger} />
                <Route exact path="/dongfangxiwang/index" component={DongFangXiWang} />

                <Route exact path="/yh_qys_electsign" component={ElectSignConfirm} />
                <Route exact path="/stb/applicant/BPMSendHiring" component={Starbucks_BPMSendHiring} />
                <Route exact path="/stb/applicant/BPMHiringApply" component={Starbucks_BPMHiringApply} />
                <Route exact path="/novastar/nova-ehr-push" component={NovaEHRPush} />
                <Route exact path="/fangtai/JobPortrait" component={JobPortrait} />
                <Route exact path="/enn/EnnSendSuccess" component={EnnSendSuccess} />
                <Route exact path="/yangguangRedirect" component={YangguangRedirect} />
                <Route exact path="/mindray/OfferBatch" component={OfferBatchComponent} />
                <Route exact path="/mindray/BaseSalary" component={BaseSalaryComponent} />
                <Route exact path="/mindray/SPSalary" component={SPSalaryComponent} />
                <Route exact path="/mindray/OperationSuccess" component={OperationSuccess} />
                <Route exact path="/xinding/index" component={xinding} />
                <Route exact path="/ZJWJ/ZjwjPush" component={ZjwjPush} />
                <Route exact path="/xinwangda/XinWangDaBackground" component={XinWangDaBackground} />
                <Route exact path="/SunshineReferrer/SunshineReferView" component={SunshineReferView} />
                <Route exact path="/Neusoft/NeusoftReferView" component={NeusoftReferView} />
                <Route exact path='/xdf-offer/index' component={XdfOffer} />
                <Route exact path='/xdf-offer/edit-applicant' component={XdfEditApplicant} />
                <Route exact path="/sinosig/question_bank" component={Sinosig_QuestionBank} />
                <Route exact path="/ShenAnTD/SAPushinfos" component={SAPushinfos} />
                <Route exact path="/cqtj/offerApply" component={Cqtj_OfferApply} />
                <Route exact path='/zhongjin/assessment/interviewer' component={AssessmentInterviewer} />
                <Route exact path='/zhongjin/assessment/hr' component={AssessmentHR} />
                <Route exact path="/haoweilai/employeapply" component={employeapply} />
                <Route exact path="/zhongjiao/evaReferView" component={ZhongJiaoReferView} />
                <Route exact path="/lingshu/backgroundrecord" component={LingShuBackGroundRecord} />
                <Route exact path='/lehe/shl/evaluation' component={SHL_Evaluation} />
                <Route exact path='/heshine/pushoa' component={HeShine} />
                <Route exact path='/zkj/ZhongKeJin' component={ZhongKeJin} />

                <Route exact path='/ccccltd-person-wish/index' component={CCCCLTDPersonWish} />
                <Route exact path='/ccccltd-person-storedb/index' component={CCCCLTDPersonStoreDB} />
                <Route exact path='/ccccltd-jump-info/index' component={CCCCLTDJumpInfo} />
                <Route exact path='/ccccltd-org-decide/index' component={CCCCLTDOrgDecide} />
                <Route exact path='/ccccltd-org-result/index' component={CCCCLTDOrgResult} />
                <Route exact path='/ccccltd-org-twice-result/index' component={CCCCLTDOrgTwiceResult} />
                <Route exact path='/ccccltd-applicant-apply/index' component={CCCCLTDApplicantApply} />

                <Route exact path='/internship-invitation/invitation' component={Invitation} />
                <Route exact path='/internship-invitation/accept' component={Accept} />
                <Route exact path='/internship-invitation/refuse' component={Refuse} />

                <Route exact path='/cspc-family-apply/index' component={CSPCFamilyApply} />

                <Route exact path='/pengxinwei/commitment-letter' component={CommitmentLetter} />
            </Layout >
        );
    }
}
